import { storeAction } from "../storeActions.constant";
import { storeGetters } from "../storeGetters.constant";
import { storeMutation } from "../storeMutations.constant";
import { getAxiosCancelTokenSource } from "../../app.utils";
import { wrapAction } from "../../common/utils/actionLifecycle";
import { axiosPost } from "../../common/utils/request";

const ypoSearchState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    peopleOneClickSearchSuggestions: {},
    peopleSearchSuggestions: {},
    eventSearchSuggestions: {},
    communitySearchSuggestions: {},
    contentSearchSuggestions: {},
};

const ypoSearchMutations = {
    [storeMutation.setPeopleOneClickSearchSuggestions]: (state, data) => {
        state.peopleOneClickSearchSuggestions = data;
    },
    [storeMutation.setPeopleSearchSuggestions]: (state, data) => {
        state.peopleSearchSuggestions = data;
    },
    [storeMutation.setEventSearchSuggestions]: (state, data) => {
        state.eventSearchSuggestions = data;
    },
    [storeMutation.setCommunitySearchSuggestions]: (state, data) => {
        state.communitySearchSuggestions = data;
    },
    [storeMutation.setContentSearchSuggestions]: (state, data) => {
        state.contentSearchSuggestions = data;
    },
    [storeMutation.resetSearchSuggestions]: (state) => {
        state.peopleOneClickSearchSuggestions = {};
        state.peopleSearchSuggestions = {};
        state.eventSearchSuggestions = {};
        state.communitySearchSuggestions = {};
        state.contentSearchSuggestions = {};
    },

};

const ypoSearchActions = {
    [storeAction.initiateTracking]: wrapAction([storeAction.initiateTracking], ({ state }, trackingObject) => {
        const requestSource = getAxiosCancelTokenSource();
        const {
            searchTerm = null,
            searchType = 'Integrated',
            tileText = null,
            tileType = null,
            oneClickSearchText = null,
            oneClickSearchType = null,
            platformName = navigator.platform,
            committedSearchTerm = null,
            interstitalType = null,
            interstitalSearchType = null, // Not needed
            interstitalSearchTerm = null, // Not needed
        } = trackingObject;
        const requestBody = {
            searchTerm,
            searchType,
            tileText,
            tileType,
            oneClickSearchText,
            oneClickSearchType,
            platformName,
            committedSearchTerm,
            interstitalType,
            interstitalSearchType,
            interstitalSearchTerm,
        };
        const requestObject = {
            actionName: storeAction.initiateTracking,
            requestSource,
        };
        return axiosPost(`${state.baseURL}search/api/SearchTracking`, {}, requestBody, requestObject.token)
            .then((res) => {
                return res;
            })
            .catch((err) => {
            //TODO: handle error here
            throw err;
        });
    }),

    [storeAction.getPeopleSearchSuggestions]: wrapAction([storeAction.getPeopleSearchSuggestions], ({ state, commit }, ypoSearchText) => {
        const requestBody = { search: ypoSearchText };
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getPeopleSearchSuggestions,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
        return axiosPost( `${state.baseURL}search/api/ams/ams-integrated-search`, {}, requestBody, requestSource.token)
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getPeopleSearchSuggestions, { root: true });
                commit(storeMutation.setPeopleSearchSuggestions, response.data);
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                 throw err;
            });
    }),
    [storeAction.getPeopleOneClickSearchSuggestions]: wrapAction([storeAction.getPeopleOneClickSearchSuggestions], ({ state, commit }, ypoSearchText) => {
        const requestBody = { search: ypoSearchText };
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getPeopleOneClickSearchSuggestions,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
        return axiosPost(`${state.baseURL}search/api/personIntegratedOneClickSearch`, {}, requestBody, requestSource.token)
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getPeopleOneClickSearchSuggestions, { root: true });
                commit(storeMutation.setPeopleOneClickSearchSuggestions, response.data);
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                throw err;
            });
    }),
    [storeAction.getEventSearchSuggestions]: wrapAction([storeAction.getEventSearchSuggestions], ({ state, commit }, ypoSearchText) => {
        const requestBody = { search: ypoSearchText };
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getEventSearchSuggestions,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
        return axiosPost(`${state.baseURL}search/api/eventIntegratedSearch`, {}, requestBody, requestSource.token)
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getEventSearchSuggestions, { root: true });
                commit(storeMutation.setEventSearchSuggestions, response.data);
                return response;
            })
            .catch((err) => {
                throw err;
            });
    }),
    [storeAction.getCommunitySearchSuggestions]: wrapAction([storeAction.getCommunitySearchSuggestions], ({ state, commit }, ypoSearchText) => {
        const requestBody = { search: ypoSearchText };
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getCommunitySearchSuggestions,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
        return axiosPost(`${state.baseURL}search/api/communityIntegratedSearch`,{}, requestBody, requestSource.token)
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getCommunitySearchSuggestions, { root: true });
                commit(storeMutation.setCommunitySearchSuggestions, response.data);
                return response;
            })
            .catch((err) => {
                 throw err;
            });
    }),
    [storeAction.getContentSearchSuggestions]: wrapAction([storeAction.getContentSearchSuggestions], ({ state, commit }, ypoSearchText) => {
        const requestBody = { search: ypoSearchText };
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getContentSearchSuggestions,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
        return axiosPost(`${state.baseURL}search/api/contentIntegratedSearch`,{}, requestBody, requestSource.token)
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getContentSearchSuggestions, { root: true });
                commit(storeMutation.setContentSearchSuggestions, response.data);
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                 throw err;
            });
    }),
};
const ypoSearchGetters = {
    [storeGetters.peopleOneClickSearchSuggestions]: state => state.peopleOneClickSearchSuggestions,
    [storeGetters.peopleSearchSuggestions]: state => state.peopleSearchSuggestions,
    [storeGetters.eventSearchSuggestions]: state => state.eventSearchSuggestions,
    [storeGetters.communitySearchSuggestions]: state => state.communitySearchSuggestions,
    [storeGetters.contentSearchSuggestions]: state => state.contentSearchSuggestions,
};

export default {
    namespaced: true,
    state: {
        initialState: ypoSearchState,
        ...ypoSearchState,
    },
    mutations: { ...ypoSearchMutations },
    actions: { ...ypoSearchActions },
    getters: { ...ypoSearchGetters },
};
